import { createFileRoute } from '@tanstack/react-router'
import { HttpStatusPage, httpStatusHead } from '@/components/http-status-page'
import type { HttpStatusData } from '@/components/http-status-page'

const data: HttpStatusData = {
  code: 522,
  name: 'Connection Timed Out',
  description:
    'A Cloudflare-specific status code meaning Cloudflare could not establish a TCP connection to the origin server within 15 seconds. The origin server is unreachable — it is either down, firewalled, or overloaded.',
  causes: [
    'The origin server is down or not listening on the expected port. The server process has crashed or was never started.',
    'A firewall, security group, or iptables rule is blocking Cloudflare\'s IP ranges from reaching the origin server.',
    'The origin server is overloaded and its TCP connection backlog is full, causing new connections to be dropped.',
  ],
  fixes: [
    'Verify the origin server is running and listening on the correct port. Check with ss -tlnp or netstat to confirm.',
    'Whitelist all Cloudflare IP ranges in your firewall. Cloudflare publishes its IP list at cloudflare.com/ips. If you restrict access to Cloudflare IPs only, ensure the list is up to date.',
    'If the server is overloaded, scale resources or reduce traffic. Check for connection limits in your server config (e.g., worker_connections in nginx).',
  ],
  monitoringTip:
    'A 522 means your server is completely unreachable from Cloudflare — this is a full outage for all users behind the CDN. Uptrack detects it within 30 seconds and alerts you once several locations confirm it, so you can restore connectivity fast.',
}

export const Route = createFileRoute('/_site/http/522')({
  component: () => <HttpStatusPage data={data} />,
  head: () => httpStatusHead(data),
})
